import { IRootState } from '../../../store'
import { IServiceState } from '../store/serviceSelection.types'

export const getServicesStateSelector = (state: IRootState): IServiceState => state.services
